<template>
	<div class="display-none-smo body-xs text-color-content-tertiary display-flex align-items-center mb-50 ellipsis">
		<div v-for="(item, index) in items" :key="index" :class="{ ellipsis: index === items.length - 1 }">
			<BaseLink class="text-color-current-color" :link="item" />
			<BaseSvgIcon
				v-if="index < items.length - 1"
				name="chevron"
				width="1em"
				height="1em"
				dir="right"
				class="ml-50 mr-50"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Link } from 'types/layout';
interface Props {
	items: Array<Link>;
}
defineProps<Props>();
</script>
